import { DOCUMENT_TYPE_COLORS, DOCUMENT_TYPE_LABELS, DocumentTypeEnum } from "app/common/enums/document-types.enum";

export interface DocumentToggle {
  field: string;
  title: string;
  icon: string;
  iconColor: string;
  description: string;
  valueChange?: string;
  disabled?: (component: any) => boolean;
  /** use to display tags*/
  tagsDocumentTypes?: {
    label: string;
    color: string
  }[];
  /** Controls the visibility of the toggle
   * undefined -> Always show
   * [] -> Always show
   * [DocumentType] -> Only show for the specified document types
  */
  showToggleForDocumentTypes?: DocumentTypeEnum[];
}

export const salesToggles: DocumentToggle[] = [
  {
    field: 'approvedRequestRequired',
    title: '¿Para crear el documento se requiere una solicitud aprobada?',
    icon: 'check_circle',
    iconColor: 'purple',
    description: 'Indica si el documento solo puede crearse con una solicitud aprobada previa.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.CAMBIO_DE_PRODUCTO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.CAMBIO_DE_PRODUCTO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.DOCUMENTO_DE_PAGO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.DOCUMENTO_DE_PAGO]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
      DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO,
      DocumentTypeEnum.CAMBIO_DE_PRODUCTO,
      DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO,
      DocumentTypeEnum.DEVOLUCION_DE_PRODUCTO,
      DocumentTypeEnum.DOCUMENTO_DE_PAGO
    ]
  },
  {
    field: 'keepsPricesOfSourceTransaction',
    title: '¿Mantiene los precios de la transacción?',
    icon: 'attach_money',
    iconColor: 'purple',
    description: 'Indica si el documento conserva los precios del documento origen.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.ENTREGA_SALIDA], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.ENTREGA_SALIDA]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.FACTURA], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.FACTURA]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
      DocumentTypeEnum.ENTREGA_SALIDA,
      DocumentTypeEnum.FACTURA
    ]
  },
  {
    field: 'keepPricingConditionsInDraft',
    title: '¿Conserva políticas comerciales del borrador?',
    icon: 'receipt_long',
    iconColor: 'purple',
    description: 'Indica si el documento mantiene las políticas comerciales del borrador.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'canUpdatePrices',
    title: '¿Permitir actualizar precio manualmente?',
    icon: 'edit',
    iconColor: 'purple',
    description: 'Permite modificar manualmente los precios en el documento.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'canTakeLostSales',
    title: '¿Permitir guardar venta perdida?',
    icon: 'trending_down',
    iconColor: 'purple',
    description: 'Captura la cantidad realmente deseada por el cliente',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'canAddItemsFromOfSourceTransaction',
    title: '¿Permitir agregar nuevas posiciones al documento?',
    icon: 'add_shopping_cart',
    iconColor: 'purple',
    description: 'Permite añadir nuevas líneas o posiciones al documento cuando se crea documento con referencia a otro.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'keepPricesCopyingTransaction',
    title: '¿Mantener precios al copiar documento?',
    icon: 'content_copy',
    iconColor: 'purple',
    description: 'Conserva los precios originales al crear un documento copiando otro.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'canAddItemsWhenCopyingTransaction',
    title: '¿Agregar posiciones al copiar documento?',
    icon: 'playlist_add',
    iconColor: 'purple',
    description: 'Permite agregar líneas adicionales al copiar un documento existente.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'hasExternalInvoice',
    title: '¿El documento ya tiene factura?',
    icon: 'receipt',
    iconColor: 'purple',
    description: 'Indica si el documento ya cuenta con una factura asociada.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.ENTREGA_SALIDA], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.ENTREGA_SALIDA]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.ENTREGA_SALIDA,
    ]
  },
  {
    field: 'allowRefundRequestOn0',
    title: '¿Permite solicitudes de reembolso?',
    icon: 'undo',
    iconColor: 'purple',
    description: 'Permite generar solicitudes de reembolso para estos documentos.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.SOLICITUD_DEVOLUCION_PRODUCTO,
      DocumentTypeEnum.SOLICITUD_CAMBIO_PRODUCTO
    ]
  },
  {
    field: 'canUnifyConditions',
    title: '¿Permite unificar con diferentes condiciones comerciales?',
    icon: 'merge_type',
    iconColor: 'purple',
    description: 'Permite unificar materiales con distintos precios',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.PEDIDO
    ]
  },
  {
    field: 'allowCreditForOverdueInvoices',
    title: '¿Permite comprar a crédito con facturas vencidas?',
    icon: 'credit_card_off',
    iconColor: 'purple',
    description: 'Determina si un cliente con facturas vencidas puede comprar a crédito. Si está deshabilitado, solo podrá comprar de contado.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.FACTURA], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.FACTURA]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.PEDIDO,
      DocumentTypeEnum.FACTURA
    ]
  },
  {
    field: 'isDirectSalesDelivery',
    title: 'Entrega para ventas directas',
    icon: 'sell',
    iconColor: 'purple',
    description: 'Permite indicar que esta clase de documento de entrega de salida será utilizada para ventas directas (pedidos facturados).',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.ENTREGA_SALIDA], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.ENTREGA_SALIDA]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.ENTREGA_SALIDA
    ]
  },
  {
    field: 'allowManualBonus',
    title: '¿Permite bonificaciones manuales?',
    icon: 'workspace_premium',
    iconColor: 'purple',
    description: 'Indica si el sistema permite registrar o aplicar bonificaciones de forma manual, sin depender de reglas o procesos automáticos.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION]},
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
    ]
  },
];


export const materialInventoryToggles: DocumentToggle[] = [
  {
    field: "makesStockReservation",
    title: "¿Puede reservar inventario?",
    icon: "inventory",
    iconColor: "yellow",
    description:
      "Permite generar reserva de inventario en los sistemas ERP, para que el pedido pueda generarse sin problema a falta de stock.",
    tagsDocumentTypes: [
      {
        label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.COTIZACION],
        color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.COTIZACION],
      },
      {
        label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO],
        color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO],
      },
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.COTIZACION,
      DocumentTypeEnum.PEDIDO,
    ],
  },
  {
    field: "makesStockValidation",
    title: "¿Válida inventario?",
    icon: "fact_check",
    iconColor: "yellow",
    description:
      "Indica si se debe validar la disponibilidad de inventario al crear el documento.",
    tagsDocumentTypes: [
      {
        label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO],
        color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO],
      },
    ],
    showToggleForDocumentTypes: [DocumentTypeEnum.PEDIDO],
  },
  {
    field: "canSeparateOrdersWithoutStock",
    title: "¿Separar documento en stock y sin stock?",
    icon: "call_split",
    iconColor: "yellow",
    description:
      "Dividir el documento en líneas con stock disponible y líneas sin stock (Crea un pedido para lo no disponible y otro para lo disponible).",
    tagsDocumentTypes: [
      {
        label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO],
        color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO],
      },
    ],
    showToggleForDocumentTypes: [DocumentTypeEnum.PEDIDO],
  },
  {
    field: "showCurrentStockForMaterials",
    title: "¿Mostrar stock de materiales?",
    icon: "remove_red_eye",
    iconColor: "yellow",
    description:
      "Muestra la cantidad de stock disponible de los materiales al crear el documento.",
    tagsDocumentTypes: [
      {
        label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO],
        color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO],
      },
    ],
    showToggleForDocumentTypes: [DocumentTypeEnum.PEDIDO],
  },
  {
    field: "showCurrentStockForMaterialsInPrinting",
    title:
      "¿Mostrar el inventario de los materiales en los documentos impresos?",
    icon: "print",
    iconColor: "yellow",
    description:
      "Incluye la información de inventario de los materiales en la impresión del documento.",
    tagsDocumentTypes: [
      {
        label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO],
        color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO],
      },
    ],
    showToggleForDocumentTypes: [DocumentTypeEnum.PEDIDO],
  },
  {
    field: "removeLeftZerosOfMaterial",
    title: "¿Remover ceros a la izquierda en material?",
    icon: "format_list_numbered",
    iconColor: "yellow",
    description: "Elimina los ceros a la izquierda en los códigos de material.",
  },
  {
    field: "appliesForInventoryDistribution",
    title: "Distribución de Inventario",
    icon: "local_shipping",
    iconColor: "yellow",
    description:
      "Define si la clase de documento aplica para distribución  de inventario",
    tagsDocumentTypes: [
      {
        label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO],
        color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO],
      },
    ],
    showToggleForDocumentTypes: [DocumentTypeEnum.PEDIDO],
  },
];


export const salesMobile: DocumentToggle[] = [
  {
    field: 'isDeliveryRouteRequired',
    title: '¿Campo Ruta de entrega requerido?',
    icon: 'assignment',
    iconColor: 'red',
    description: 'Al no conectarse con AVE para entrega se envía a SAP de forma inferida la ruta que atendera',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'automaticallyAssignedATrip',
    title: '¿Se le asigna automáticamente un viaje?',
    icon: 'local_shipping',
    iconColor: 'red',
    description: 'Proceso que asigna viajes a la entregas que se cargan por importación.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.ENTREGA_SALIDA], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.ENTREGA_SALIDA]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.ENTREGA_SALIDA,
    ]
  },
  {
    field: 'enableDraftOrder',
    title: 'Activar borrador de Pedido',
    icon: 'drafts',
    iconColor: 'red',
    description: 'Permite generar la subida de documentos para ser leídos como borrador, basados en oficina.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.PEDIDO,
    ]
  },
  {
    field: 'allowBonusOnDeliveryRejection',
    title: 'Rechazo de entrega ¿libera bonificación para libre uso como obsequio?',
    icon: 'card_giftcard',
    iconColor: 'red',
    description: 'Permite liberar bonificaciones promocionales para uso libre como obsequios de un rechazo de entrega.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.ENTREGA_SALIDA], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.ENTREGA_SALIDA]}
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.ENTREGA_SALIDA,
    ]
  }
];

export const salesMobileSectionCreate: DocumentToggle[] = [
  {
    field: 'applyToSubRouteGroup',
    title: '¿Aplica para todos los grupos de rutas?',
    icon: 'route',
    iconColor: 'red',
    description: 'Define si la clase de documento aplica para todos los grupos de rutas',
    valueChange: 'onToggleApplyToGroupRoutes'
  },
  {
    field: 'applyToAllSubRoutes',
    title: '¿Aplica para todas las rutas?',
    icon: 'alt_route',
    iconColor: 'red',
    description: 'Define si la clase de documento aplica para todos las rutas',
    valueChange: 'onToggleApplyToAllRoutes',
    disabled: (component) => component.currentCreateDocumentClass.applyToSubRouteGroup
  },
  {
    field: 'applyToAllSalesOffices',
    title: '¿Aplica para todas las oficinas de venta?',
    icon: 'domain',
    iconColor: 'red',
    description: 'Define si la clase de documento aplica para todas las oficinas de venta',
    valueChange: 'onToggleApplyToAllSalesOffice',
  },
  {
    field: 'activateBonusWithoutStock',
    title: 'Activar bonificación sin stock',
    icon: 'redeem',
    iconColor: 'red',
    description: 'Permite activar bonificaciones aunque no haya stock disponible.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.PEDIDO
    ]
  }
];

export const salesMobileSectionUpdate: DocumentToggle[] = [
  {
    field: 'applyToSubRouteGroup',
    title: '¿Aplica para todos los grupos de rutas?',
    icon: 'route',
    iconColor: 'red',
    description: 'Define si la clase de documento aplica para todos los grupos de rutas',
    valueChange: 'onToggleApplyToGroupRoutesUpdate'
  },
  {
    field: 'applyToAllSubRoutes',
    title: '¿Aplica para todas las rutas?',
    icon: 'alt_route',
    iconColor: 'red',
    description: 'Define si la clase de documento aplica para todos las rutas',
    valueChange: 'onToggleApplyToAllRoutesUpdate',
    disabled: (component) => component.currentUpdateDocumentClass.applyToSubRouteGroup
  },
  {
    field: 'applyToAllSalesOffices',
    title: '¿Aplica para todas las oficinas de venta?',
    icon: 'domain',
    iconColor: 'red',
    description: 'Define si la clase de documento aplica para todas las oficinas de venta',
    valueChange: 'onToggleApplyToAllSalesOffice',
  },
  {
    field: 'activateBonusWithoutStock',
    title: 'Activar bonificación sin stock',
    icon: 'redeem',
    iconColor: 'red',
    description: 'Permite activar bonificaciones aunque no haya stock disponible.',
    tagsDocumentTypes: [
      { label: DOCUMENT_TYPE_LABELS[DocumentTypeEnum.PEDIDO], color: DOCUMENT_TYPE_COLORS[DocumentTypeEnum.PEDIDO]},
    ],
    showToggleForDocumentTypes: [
      DocumentTypeEnum.PEDIDO
    ]
  }
];